<template>
  <div class="view-benefit">

    <ModalForm :showModal="showModal" :action="BenefitCategory.updateWizard.action">
        <template slot="form">
          <CustomForm 
              :pages="BenefitCategory.updateWizard.pages" 
              :action="BenefitCategory.updateWizard.action" 
              :buttonText="BenefitCategory.updateWizard.actionBtn" 
              :showTitle="false">
          </CustomForm>
        </template>
    </ModalForm>

    <ModalForm :showModal="showVerifyModal" :action="BenefitCategory.verifyWizard.action">
        <template slot="form">
          <CustomForm 
              :pages="BenefitCategory.verifyWizard.pages" 
              :action="BenefitCategory.verifyWizard.action" 
              :buttonText="BenefitCategory.verifyWizard.actionBtn" 
              :showTitle="false">
          </CustomForm>
        </template>
    </ModalForm>

    <div class="card mg-b-20 mg-lg-b-25">
      <div class="card-header pd-y-15 pd-x-20 d-flex align-items-center justify-content-center">
        <h5 class="tx-uppercase tx-bold mg-b-0">View benefit</h5>
      </div>
      <!-- card-header -->
      <div class="card-body pd-20 pd-lg-25">
        <div class="row">
          <div class="col-md-6">
            <div class="media mg-b-20">
              <div class>Ref :</div>
              <div class="media-body pd-l-15">
                <h6 class>{{ benefit.benefit_category_ref || ''}}</h6>
              </div>
            </div>
            <!-- media -->
            <div class="media mg-b-20">
              <div class>Name :</div>
              <div class="media-body pd-l-15">
                <h6 class>{{ benefit.benefit_category_name || "" }}</h6>
              </div>
            </div>
            <!-- media -->
            <div class="media mg-b-20">
              <div class>Description :</div>
              <div class="media-body pd-l-15">
                <h6 class>{{ benefit.benefit_category_description || ''}}</h6>
              </div>
            </div>
            <!-- media -->
            <div class="media mg-b-20">
              <div class>Status :</div>
              <div class="media-body pd-l-15">
                <h6 class>{{ benefit.status || ''}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer bg-transparent pd-y-10 pd-sm-y-15 pd-x-10 pd-sm-x-20">
        <nav class="nav nav-with-icon tx-13">
          <button class="btn btn-sm" @click="editBenefit">
            <i data-feather="edit"></i> Edit
          </button>
          <button class="btn btn-sm mg-l-20" @click="verifyBenefit">
            <i data-feather="thumbs-up"></i> Verify
          </button>
          
        </nav>
      </div>
      <!-- card-footer -->
    </div>
    <!-- card -->
  </div>
</template>

<script>
export default {
  created() {
    this.BenefitCategory = Models.BenefitCategory
    Event.$on('form:submit', async (payload) => {
      if(payload.action === this.BenefitCategory.updateWizard.action){
          await this.updateBenefitCategory(payload.formData)
          this.showModal = false
      } else if(payload.action === this.BenefitCategory.verifyWizard.action){
        await this.verifyBenefitCategory(payload.formData)
        this.showVerifyModal = false
      } 
    })
  },
  data() {
    return {
      benefit: {},
      showModal: false,
      showVerifyModal: false,
    };
  },
  methods: {
    verifyBenefit() {
      this.showVerifyModal = true
    },
    editBenefit() {
      // let pages = this.BenefitCategory.updateWizard.pages[0]
      // pages.forms[0].value = this.benefit.benefit_category_description
      // pages.forms[0].model = this.benefit.benefit_category_description
      this.showModal = true
    },

    
    updateBenefitCategory(data) {

      return new Promise(async (resolve,reject) => {
          try {
            let res = await req.callServerSecure({
                resource: "benefit_category",
                action: "update",
                data: {
                  benefit_category_ref: this.$route.params.id,
                  data: {
                    benefit_category_name: data.benefit_category_name,
                    benefit_category_image_path: data.benefit_category_image_path,
                    benefit_category_description: data.benefit_category_description,
                  }
                },
                meta_data: {},
            });

            await this.fetchBenefit()
            notification.notify('success', 'Benefit Category Updated', `The BenefitCategory ${this.benefit.benefit_category_name} was successfully updated`)
            Event.$emit('form:action-complete',{action: this.BenefitCategory.updateWizard.action, clear: true})
            this.showModal = false
          } catch (err) {
            Event.$emit('form:action-error',{action: this.BenefitCategory.updateWizard.action})
          }
      })
    },

    verifyBenefitCategory(data) {

      return new Promise(async (resolve,reject) => {
          try {
            let res = await req.callServerSecure({
                resource: "benefit_category",
                action: "verify",
                data: {
                  benefit_category_ref: this.$route.params.id,
                  remarks: data.remarks,
                  audit_id: 1113
                },
                meta_data: {},
            });


            await this.fetchBenefit()
            notification.notify('success', 'Benefit Category Updated', `The BenefitCategory ${this.benefit.benefit_category_name} was successfully verified`)
            Event.$emit('form:action-complete',{action: this.BenefitCategory.verifyWizard.action, clear: true})
            this.showVerifyModal = false
          } catch (err) {
            Event.$emit('form:action-error',{action: this.BenefitCategory.verifyWizard.action})
          }
      })
    },

    fetchBenefit() {
        return new Promise(async (resolve, reject) => {
            try {
            let res = await req.callServerSecure({
                resource: "benefit_category",
                action: "view",
                data: {
                    benefit_category_ref: this.$route.params.id,
                },
            });
            console.log(res)

            this.benefit = res.data.result.benefit_category;

            resolve();
            } catch (err) {
            console.log(err);
            reject(err);
            }
        });
    },

    getIcons () {
            return new Promise(async (resolve,reject) => {
               try {
                  let pages = this.BenefitCategory.wizard.pages;
                  let res = await req.callServerSecure({
                     resource: "icons",
                     action: "list",
                     data: {
                 
                     },
                     meta_data: {},
                  });
                  pages[0].forms[1].options = utils.appendOptions(
                      res.data.result,
                      "file_path",
                      "originalname",
                  ),
                  resolve(true)
               } catch (err) {
                  reject(err)
               }
            })
         }
  },
  async mounted() {
    await this.fetchBenefit();
    await this.getIcons();
    Event.$emit("loader:show", false);
  },
};
</script>

<style>
</style>